import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import BackAnchor from "../../../../shared/components/BackAnchor";
import { addToGoogleDataLayer } from "../../../../shared/const/utls";
import ContinueCancelButtons from "../../../../shared/components/ContinueCancelButtons";
import { useDispatch } from "react-redux";
import { setQuestionAnswer } from "../../../../redux/actions";
import { Link } from "@mui/material";

const HARPMessageView = ({ t, i18n }) => {
  const navigate = useNavigate();
  const { search } = useLocation();
  const question = search?.substring(10);
  const dispatch = useDispatch();
  const [infoMessage, setInfoMessage] = useState(null);
  // const [infoMessage_2, setInfoMessage_2] = useState(null);
  const [backPath, setBackPath] = useState(null);
  const [nextPath, setNextPath] = useState(null);

  useEffect(() => {
    if (question === "single_parent") {
      if (i18n?.language === "en") {
        document.title =
          "To apply as single parent - HARP- Government of Nova Scotia";
      } else {
        document.title =
          "To apply as single parent - HARP - Gouvernement de la Nouvelle-Écosse";
      }
      setInfoMessage(t("harp_info_text.single_parent"));
      setBackPath(t("routes.household_type"));
      setNextPath(t("routes.harp_income"));
    } else if (question === "harp_tax_file") {
      if (i18n?.language === "en") {
        document.title =
          "You can still apply - HARP- Government of Nova Scotia";
      } else {
        document.title =
          "Vous pouvez quand même soumettre une demande - Allocation pour services à domicile chez les aînés - Gouvernement de la Nouvelle-Écosse";
      }
      // setInfoMessage(
      //   t("seniors_adult_info_message.harp_tax_file").replace(
      //     "#YEAR",
      //     currentLanguageDates?.taxFiled
      //   )
      // );
      setBackPath(t("routes.harp_tax_file"));
      // setInfoMessage_2(
      //   t("seniors_adult_info_message.harp_tax_file_2").replace(
      //     "#YEAR",
      //     currentLanguageDates?.taxFiled
      //   )
      // );
      setNextPath(t("routes.health_service_spend"));
    }
  }, [question, t, i18n.language]);

  useEffect(() => {
    // if (!disableGApush) {
    try {
      addToGoogleDataLayer(
        "live-independently-check",
        "HARP Application",
        i18n.language
      );
      window.scrollTo(0, 0);
    } catch (e) {
      console.log(e);
    }
    // }
  }, [i18n.language]);

  const onNext = () => {
    try {
      if (
        question !== "harp_tax_file" ||
        question !== "seniors_and_other_adult_tax_file"
      ) {
        dispatch(setQuestionAnswer(15, question));
      }
      if (nextPath) {
        navigate(`/${i18n.language}${nextPath}`);
      } else {
        navigate(`/${i18n.language}${t("routes.harp_income")}`);
      }
    } catch (e) {
      console.log(e);
    }
  };

  const handleReduxCleanup = () => {
    dispatch(setQuestionAnswer(15, ''));
  }


  return (
    <div>
      <div className="container">
        <main>
          <article>
            <div className="row" style={{ paddingTop: "1em" }}></div>
            <BackAnchor backPath={backPath} onBackClick={handleReduxCleanup} />
            <div className="row">
              <div className="col-xs-12 col-sm-8 ">
                <h2>{infoMessage}{question == "single_parent" && <Link
                  href="https://www.canada.ca/en/revenue-agency/services/child-family-benefits/canada-child-benefit-overview.html"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ cursor: "pointer" }}
                >{t("harp_info_text.single_parent_link")}</Link>}{t("harp_info_text.canada_child_benifit")}</h2>
              </div>
              {/* <div className="col-xs-12 col-sm-8">
                <p>{infoMessage_2}</p>
              </div> */}
            </div>
            <ContinueCancelButtons
              continueClick={onNext}
              isSignatureRequired={false}
            />
          </article>
        </main>
      </div>
    </div>
  );
};

export default withTranslation("common")(HARPMessageView);
